import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'

export type OriginalChangeCaseEventType = string

export type OriginalChangeCasePayload = Record<string, unknown>

export type OriginalChangeCaseAttachment = {
  label: string
  url?: string
}

type OriginalChangeCaseRpcClient = {
  rpc: (
    name: 'create_original_change_case',
    args: {
      p_event_type: OriginalChangeCaseEventType
      p_changed_at: string
      p_target_status: string | null
      p_studio_internal_ids: number[]
      p_payload: OriginalChangeCasePayload
      p_comment: string | null
      p_attachments: OriginalChangeCaseAttachment[]
    }
  ) => Promise<{
    data: number | null
    error: { message?: string } | null
  }>
}

export async function createOriginalChangeCase(params: {
  eventType: OriginalChangeCaseEventType
  changedAt: string
  targetStatus?: string | null
  studioInternalIds: number[]
  payload?: OriginalChangeCasePayload
  comment?: string | null
  attachments?: OriginalChangeCaseAttachment[]
}): Promise<number> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as unknown as OriginalChangeCaseRpcClient).rpc('create_original_change_case', {
      p_event_type: params.eventType,
      p_changed_at: params.changedAt,
      p_target_status: params.targetStatus || null,
      p_studio_internal_ids: params.studioInternalIds,
      p_payload: params.payload ?? {},
      p_comment: params.comment?.trim() || null,
      p_attachments: params.attachments ?? [],
    })
  )) as { data: number | null; error: { message?: string } | null }

  if (error) throw error
  if (data == null) throw new Error('Кейс не создан')
  return Number(data)
}
